import React from 'react';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const CopyIcon = () => (
  <Icon tooltip="Copy" iconObj={faCopy} />
);

export default CopyIcon;